import { useSelector } from 'react-redux';
export const selectUserContext = (state) => state.userContext;
export const selectUserRoles = (state) => state.userContext.innovyzeRole;
export const selectEntitlements = (state) => state.userContext.entitlements;
export const useSelectUserContext = () => useSelector(selectUserContext);
export const userContextEmulationSelector = (state) => !!state.userContext.inEmulation;
export const useSelectUserContextEmulation = () => useSelector(userContextEmulationSelector);
